import { useLanguage } from '../context/LanguageContext';
import { ServiceItem } from '../i18n/serviceItems';

export const useServiceItems = (): ServiceItem[] => {
  const { t } = useLanguage();
  return t.services.items;
};

export const useServiceBySlug = (slug: string) => {
  const items = useServiceItems();
  const index = items.findIndex((item) => item.slug === slug);
  const service = index >= 0 ? items[index] : undefined;

  return {
    service,
    index,
    prev: index > 0 ? items[index - 1] : undefined,
    next: index >= 0 && index < items.length - 1 ? items[index + 1] : undefined,
  };
};
